import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostBinding,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RichTextControlModalComponent } from "../../rich-text/form/rich-text-control-modal.component";
import { ModalController } from "ionic-angular";
import { Subject } from "rxjs/Subject";
import { ControlComponent } from "../../control.component";
import { PassAlertFailFieldItemValue } from "./pass-alert-fail-control-item-value.model";
import { RichTextModalArgs } from "../../rich-text/form/rich-text-control-modal-args.model";
import { PassAlertFailControl } from "../pass-alert-fail-control.model";
import { isDefined } from "ionic-angular/util/util";
import { stripHtml } from "../../../../core/util/utils";

@Component({
    selector: "passalertfail-item",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ion-grid>
            <ion-row>
                <ion-col col-12>
                    <ion-segment item-content [ngModel]="result" (ionChange)="onResultChange($event)">
                        <ion-segment-button value="1" color="success">
                            <ion-icon name="thumbs-up" color="success"></ion-icon>
                        </ion-segment-button>
                        <ion-segment-button value="0" color="warning">
                            <ion-icon name="alert" color="warning"></ion-icon>
                        </ion-segment-button>
                        <ion-segment-button value="-1" color="danger">
                            <ion-icon name="thumbs-down" color="danger"></ion-icon>
                        </ion-segment-button>
                    </ion-segment>
                </ion-col>
                <ion-col col-12>
                    <textarea #commentInput [value]="comment" (change)="onTextAreaKeyDown($event)"></textarea>
                </ion-col>
            </ion-row>
        </ion-grid>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PassAlertFailControlItemComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => PassAlertFailControlItemComponent), multi: true}
    ]
})
export class PassAlertFailControlItemComponent extends ControlComponent {
    @Input() definition: PassAlertFailControl;
    @Input() formControl: FormControl;
    @Input("value") _value: PassAlertFailFieldItemValue = {} as any;
    @Output() changes: EventEmitter<any> = new EventEmitter();
    @HostBinding("class") classes = "item item-block item-md";

    @ViewChild("commentInput") $comment: ElementRef;


    constructor(
        protected elemRef: ElementRef,
        protected modalCtl: ModalController
    ) {
        super(elemRef);
    }

    get comment(): string {
        return isDefined(this.value) ? this.value.comment : "";
    }

    get commentInputValue(): string {
        return isDefined(this.$comment) ? (this.$comment.nativeElement.value || "") : "";
    }

    get result(): string {
        return this.value.result;
    }

    onResultChange($event): void {
        this.updateValue({
            ...this.value,
            result: $event.value
        });
    }

    onTextAreaKeyDown($event): void {
        $event.stopPropagation();
        this.updateValue({
            ...this.value,
            comment: stripHtml(this.commentInputValue)
        });
    }

    editComment(): void {
        const modal = this.modalCtl.create(RichTextControlModalComponent, new RichTextModalArgs("Comment", this.comment));

        modal.onDidDismiss(value => {
            this.updateValue({
                ...this.value,
                ...{
                    comment: value
                }
            });
        });

        modal.present();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control-item.component.ts